// Query keys for the checkout "Today's Items" panel
// (GET billing/charge/todays-items/{patientId}). Centralized so the query
// sites and the mutations that should invalidate them stay in sync.
export const todaysItemsQueryKeys = {
  all: ["todays-items"] as const,
  patient: (patientId: string | null | undefined) =>
    [...todaysItemsQueryKeys.all, patientId] as const,
  // Checkout v2 asks the server to ignore the charges it already has open, so
  // those ids are part of the identity of the response. Prefixed by
  // `patient()` so invalidating a patient still catches every variant.
  patientExcluding: (
    patientId: string | null | undefined,
    excludeChargeIds: string[],
  ) => [...todaysItemsQueryKeys.patient(patientId), excludeChargeIds] as const,
};
